import React, { Component } from "react";
import { Button, Paper } from "@material-ui/core";
import { GetWalletDetails } from "../../../../services";
import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";

export default class Edit extends Component {
  constructor(props) {
    super(props);
    const walletdata = this.props.location.state;

    this.state = {
      isLoaded: false,
      id: walletdata.id,
      amount: walletdata.amount,
      status: walletdata.status === "Active" ? "Active" : "Inactive",
    };
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleBack() {
    this.props.history.goBack();
  }

  handleSubmit = async () => {
    this.setState({ isLoaded: true });

    const { id, amount, status } = this.state;

    if (!amount) {
      NotificationManager.error("Amount is required", "Input Error");
      this.setState({ isLoaded: false });
      return;
    }

    const data = {
      id,
      amount: Number(amount),
      status: status, // "Active" | "Inactive"
    };
    const wallet = await GetWalletDetails.getWalletPackageUpdate(data);
    this.setState({ isLoaded: false });

    if (wallet) {
      NotificationManager.success("Update success", "Message");
      this.props.history.goBack();
    } else {
      NotificationManager.error("Check field", "Input");
    }
  };

  render() {
    const { isLoaded, amount, status } = this.state;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9">
            <h2 className="mt-30 page-title">Update Wallet Package</h2>
          </div>
          <div className="col-lg-5 col-md-3 back-btn">
            <Button variant="contained" onClick={() => this.handleBack()}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>

        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">Dashboard</li>
          <li className="breadcrumb-item">Wallet</li>
        </ol>

        <Paper className="user-management" style={{ padding: "1rem" }}>
          {isLoaded && <Loader />}

          <div className="row">
            <div className="col-md-6 form-group">
              <label>Amount (₹)</label>
              <input
                type="number"
                className="form-control"
                name="amount"
                value={amount}
                onChange={(e) => this.handleChange(e)}
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Status</label>
              <select
                className="form-control"
                name="status"
                value={status}
                onChange={(e) => this.handleChange(e)}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          <button
            className="btn btn-success col-sm-3 mt-3 py-2"
            onClick={this.handleSubmit}
          >
            Update
          </button>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/wallet/edit/index.js